<template>
  <el-main>
    <el-row type="flex">
      <el-button style="margin-right: 10px;" width="100px;" type="primary" @click="getList">{{$t('default.refresh')}}<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-select
      style="margin-right: 10px;" @change="getList" v-model="reportType" placeholder="">
        <el-option
          key="eye"
          :label="$t('default.title1')"
          value="eye">
        </el-option>
        <el-option
          key="vessel"
          :label="$t('default.title2')"
          value="vessel">
        </el-option>
        <el-option
          key="all"
          :label="$t('default.title3')"
          value="all">
        </el-option>
        <el-option
          key=""
          :label="$t('default.allReport')"
          value="">
        </el-option>
      </el-select>
      <el-cascader
        clearable
        :placeholder="$t('default.allDiseases')"
        style="margin-right: 10px;width: 350px;"
        v-model="diseasesFilter"
        @change="getList"
        :options="options"></el-cascader>
      <!-- <el-select style="margin-right: 10px;" @change="getList" v-model="machineId" placeholder="请选择机器">
        <el-option
          key=""
          label="所有"
          value="">
          所有数据
        </el-option>
        <el-option
          v-for="machine in machineIds"
          :key="machine.machineId"
          :value="machine.machineId" >
          {{machine.machineRemark ? machine.machineRemark : machine.machineId }}
        </el-option>
      </el-select> -->
      <el-select v-if="user.type!== 'normal'" style="margin-right: 10px;" @change="getListAndAccounts" v-model="organizationId">
        <el-option
          key="all"
          :label="$t('default.allOrganization')"
          value="all">{{$t('default.allOrganization')}}
        </el-option>
        <el-option
          v-for="or in organizations"
          :key="or._id"
          :value="or._id"
          :label="or.name">
        </el-option>
      </el-select>
      <el-select
        v-if="user.type !== 'normal'" style="margin-right: 10px;" @change="getList" v-model="accountId">
        <el-option
          key=""
          :label="$t('default.allAccount')"
          value="">{{ $t('default.allAccount') }}
        </el-option>
        <el-option
          v-for="account in accountIds"
          :key="account._id"
          :value="account._id"
          :label="account.username">
        </el-option>
      </el-select>
      <el-col :span="5" style="margin-right: 10px;">
        <el-input :placeholder="$t('default.IDText')" v-model="patientId" class="input-with-select">
          <el-button @click="getList" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>
      <el-col :span="5" style="margin-right: 10px;">
        <el-input :placeholder="$t('default.assistantId')" v-model="assistantId" class="input-with-select">
          <el-button @click="getList" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>
      <el-col :span="5" style="margin-right: 10px;">
        <el-input :placeholder="$t('default.NameText')" v-model="search" class="input-with-select">
          <el-button @click="getList" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>
      <el-date-picker
        style="margin-right: 10px;"
        v-model="pickerDate"
        @change="getList"
        type="daterange"
        :range-separator="$t('default.to')"
        :start-placeholder="$t('default.startDate')"
        :end-placeholder="$t('default.endDate')">
      </el-date-picker>
      <el-button style="margin-right: 10px;" width="100px;" type="primary" @click="exportReports">{{$t('default.export')}}</el-button>
    </el-row>
    <el-table style="margin-top: 10px" border v-loading="loading" :data="gradings">
      <!-- <el-table-column prop="fileName" label="ID" >
      </el-table-column> -->
      <el-table-column prop="createdAt" :label="$t('default.uploadText')" width="200px">
        <template slot-scope="scope">
          {{getDate(scope.row.createdAt)}}
        </template>
      </el-table-column>
      <el-table-column prop="patientId" label="ID"  width="150px" >
      </el-table-column>
      <el-table-column prop="assistantId" :label="$t('default.assistantId')"  width="150px" >
      </el-table-column>
      <el-table-column prop="name" :label="$t('default.name')"  width="100px">
      </el-table-column>
      <el-table-column prop="gender" :label="$t('default.gender')"  width="70px">
        <template slot-scope="scope">
          {{genderMap[scope.row.gender]}}
        </template>
      </el-table-column>
      <el-table-column prop="age" :label="$t('default.age')" width="60px">
      </el-table-column>
      <el-table-column prop="reportType" :label="$t('default.reportType')" width="220px">
        <template slot-scope="scope">
          {{reportTypeMap[scope.row.reportType]}}
        </template>
      </el-table-column>
      <el-table-column v-if="user.type !== 'normal'" prop="accountId" label="Account"  width="150px">
        <template slot-scope="scope">
          {{accountIdMap[scope.row.accountId] || scope.row.accountId}}
        </template>
      </el-table-column>
      <el-table-column width="120px" prop="diseases" :label="$t('default.fundus')">
        <template slot-scope="scope">
          <span v-if="scope.row.reportVersion === 'v2' || scope.row.reportVersion === 'polymindamd'">
            <span style="color: red" v-if="(scope.row.od.result && !scope.row.od.result.public.image_capture) || (scope.row.od.result && !scope.row.od.result.public.image_capture)"> {{ $t('default.fail') }}</span>
            <span v-else>{{ $t('default.success') }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column width="400px" prop="diseases" :label="$t('default.Diseases')">
        <template slot-scope="scope">
          <!-- {{machineMap[scope.row.machineId] && machineMap[scope.row.machineId].machineRemark ? machineMap[scope.row.machineId].machineRemark : scope.row.machineId}} -->
          <span :key="d.disease" v-for="d in scope.row.diseasesResults">
            <el-tag style="margin-right: 10px; margin-bottom: 10px;" v-if="d.result" :type="getClass(d.result, d.disease)">
              {{ diseasesMap[d.disease] }}
            </el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('default.actions')">
        <template slot-scope="scope">
          <el-button @click="openReport(scope.row)" type="text" size="small">{{$t('default.viewReport')}}</el-button>
          <el-button @click="openReportQRCode(scope.row)" type="text" size="small">QR Code</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="prev, pager, next, total"
      :total="total">
    </el-pagination>
    <el-dialog
      :visible.sync="qrCodeVisible"
      width="300px;">
      <div style="text-align: center">
        <p style="text-align: center">
          ID:{{ qrID }}
        </p>
        <img :src="qrCode" alt="">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrCodeVisible = false">Ok</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  .el-aside {
    color: #333;
  }
  .ungradable {
    /* color: orangered; */
  }
  .positive {
    color: red
  }
  .negative {
  }
</style>

<script>
// import oss from '../utils/oss'
import XLSX from 'xlsx'
import xlsxUtil from '../utils/xlsx'
import { mapState } from 'vuex'
import qr from 'qr-image'
import moment from 'moment'
export default {
  data () {
    return {
      loading: false,
      mode: 'ai',
      machineId: '',
      machineIds: [],
      organizations: [],
      organizationId: 'all',
      organizationsMap: {},
      accountId: '',
      accountIdMap: {},
      accountIds: [],
      reportVisible: false,
      pickerDate: null,
      list: [],
      allList: [],
      search: '',
      patientId: '',
      assistantId: '',
      gradings: [],
      machineMap: {},
      qrCodeVisible: false,
      qrID: '',
      qrCode: '',
      reportType: '',
      reportTypeMap: {
        eye: this.$t('default.title1'),
        vessel: this.$t('default.title2'),
        all: this.$t('default.title3')
      },
      genderMap: {
        male: this.$t('default.male'),
        female: this.$t('default.female')
      },
      diseasesMap: {
        dr: this.$t('default.dr'),
        amd: this.$t('default.amd'),
        cataract: this.$t('default.cataract'),
        glaucoma: this.$t('default.glaucoma'),
        drnp: this.$t('default.dr'),
        other: this.$t('default.other'),
        cvd: this.$t('default.cvdPoint'),
        fundus: this.$t('default.fundus')
      },
      pageSize: 10,
      total: 0,
      currentPage: 1,
      diseasesFilter: [],
      options: [{
        value: 'drnp',
        label: this.$t('default.dr'),
        children: [{
          value: 'ungradable',
          label: this.$t('default.ungradable')
        }, {
          value: 'negative',
          label: this.$t('default.negative')
        }, {
          value: 'positive',
          label: this.$t('default.positive')
        }]
      }, {
        value: 'cataract',
        label: this.$t('default.cataract'),
        children: [{
          value: 'ungradable',
          label: this.$t('default.ungradable')
        }, {
          value: 'negative',
          label: this.$t('default.negative')
        }, {
          value: 'positive',
          label: this.$t('default.positive')
        }]
      }, {
        value: 'glaucoma',
        label: this.$t('default.glaucoma'),
        children: [{
          value: 'ungradable',
          label: this.$t('default.ungradable')
        }, {
          value: 'low risk',
          label: this.$t('default.low_risk')
        }, {
          value: 'medium risk',
          label: this.$t('default.medium_risk')
        }, {
          value: 'high risk',
          label: this.$t('default.high_risk')
        }]
      }, {
        value: 'amd',
        label: this.$t('default.amd'),
        children: [{
          value: 'ungradable',
          label: this.$t('default.ungradable')
        }, {
          value: 'negative',
          label: this.$t('default.negative')
        }, {
          value: 'early_or_intermediate',
          label: this.$t('default.early_or_intermediate')
        }, {
          value: 'late_dry',
          label: this.$t('default.late_dry')
        }, {
          value: 'late_wet',
          label: this.$t('default.late_wet')
        }]
      }, {
        value: 'cvd',
        label: this.$t('default.cvdPoint'),
        children: [{
          value: 'Ungradable',
          label: this.$t('default.ungradable')
        }, {
          value: 'N/A',
          label: 'N/A'
        }, {
          value: 'low risk',
          label: this.$t('default.low_risk')
        }, {
          value: 'medium risk',
          label: this.$t('default.medium_risk')
        }, {
          value: 'high risk',
          label: this.$t('default.high_risk')
        }]
      }
      ]
    }
  },
  mounted: async function () {
    await this.getAllUserAccountId()
    await this.getAllOrganizations()
    this.getList()
    console.log(this.user)
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    async getAllOrganizations () {
      let result = {}
      try {
        result = await this.$store.dispatch('getAllOrganizations')
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.organizations = data.organizations
        this.organizations.map((account) => {
          this.organizationsMap[account._id] = account.name
        })
      }
    },
    async getListAndAccounts () {
      this.getList()
      this.getAllUserAccountId()
    },
    async getAllUserAccountId () {
      let result = {}
      try {
        result = await this.$store.dispatch('getAllUserAccountId', {
          organizationId: this.organizationId
        })
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.accountIds = data.users
        this.accountIds.map((account) => {
          this.accountIdMap[account._id] = account.username
        })
      }
    },
    async getMachineIds () {
      let result = {}
      try {
        result = await this.$store.dispatch('getMachineIds')
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.machineIds = data.keys
        this.machineIds.forEach((machine) => {
          this.machineMap[machine.machineId] = machine
        })
      }
    },
    async exportReports () {
      this.loading = true
      let result = {}
      if (!this.pickerDate) {
        this.pickerDate = []
      }
      try {
        result = await this.$store.dispatch('getAllGradings', {
          mode: this.mode,
          patientId: this.patientId,
          assistantId: this.assistantId,
          disease: this.diseasesFilter[0] || '',
          diseaseGrading: this.diseasesFilter[1] || '',
          startDate: this.pickerDate[0] ? new Date(this.pickerDate[0]) : '',
          endDate: this.pickerDate[1] ? moment(this.pickerDate[1]).endOf('day').toDate() : '',
          organizationId: this.organizationId || 'all',
          accountId: this.accountId || 'all',
          // machineId: this.machineId,
          state: 'graded'
        })
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.allList = data.gradings
        this.exportSheet()
      }
      this.loading = false
    },
    getProd: function (od, os, odQuality, osQuality, age) {
      if (age) {
        if (age < 40 || age > 80) {
          return 'N/A'
        }
      } else {
        return 'N/A'
      }
      if (od && os) {
        if ((od - os) >= -9 && (od - os) <= 11) {
          return false
        } else {
          return 'N/A'
        }
      } else {
        return false
      }
    },
    getRank: function (od, os, odQuality, osQuality, age) {
      console.log(od, os, odQuality, osQuality, age)
      if (osQuality === 'Reject' || !osQuality) {
        os = null
      }
      if (odQuality === 'Reject' || !odQuality) {
        od = null
      }
      const prodResult = this.getProd(od, os, odQuality, osQuality, age)
      if (prodResult) {
        return prodResult
      }
      let average
      // 眼镜88显示低风险等
      if (od === null && os === null) {
        return 'Ungradable'
      } else if (od === null) {
        average = (os)
      } else if (os === null) {
        average = (od)
      } else {
        average = ((od + os) / 2)
      }
      if (average < 10) {
        return 'low risk'
      }
      if (average >= 10) {
        return 'medium risk'
      }
      if (average >= 20) {
        return 'high risk'
      }
    },
    exportSheet () {
      const sheet = {}
      const eyes = ['od', 'os']
      const table = this.allList.map((t, index) => {
        const doc = {
          index: index + 1,
          _id: t._id,
          createdAt: t.createdAt && this.getDate(t.createdAt),
          ID: t.patientId,
          Account: this.accountIdMap[t.accountId] || t.accountId,
          assistantId: t.assistantId,
          name: t.name,
          age: t.age,
          birthday: t.birthday,
          diseases: t.diseases,
          gender: t.gender,
          address: t.address,
          mobile: t.mobile,
          machineId: t.machineId,
          fileName: t.fileName,
          od_url: t.od.url,
          os_url: t.os.url
        }
        try {
          if (t.od.images) {
            doc.od_url = t.od.images.map((img) => {
              if (img.result && img.result.vessel) {
                doc.od_artery_image = img.result.vessel.artery_image && img.result.vessel.artery_image.replace('oss-cn-hongkong', 'oss-accelerate')
                doc.od_ratio_image = img.result.vessel.ratio_image && img.result.vessel.ratio_image.replace('oss-cn-hongkong', 'oss-accelerate')
                doc.od_segmentation_image = img.result.vessel.segmentation_image && img.result.vessel.segmentation_image.replace('oss-cn-hongkong', 'oss-accelerate')
                doc.od_resized_image = img.result.vessel.resized_image && img.result.vessel.resized_image.replace('oss-cn-hongkong', 'oss-accelerate')
              }
              return img.url
            })
            doc.od_url = doc.od_url.join(',')
            doc.od_url = doc.od_url.replace('oss-cn-hongkong', 'oss-accelerate')
          }
          if (t.os.images) {
            doc.os_url = t.os.images.map((img) => {
              if (img.result && img.result.vessel) {
                doc.os_artery_image = img.result.vessel.artery_image && img.result.vessel.artery_image.replace('oss-cn-hongkong', 'oss-accelerate')
                doc.os_ratio_image = img.result.vessel.ratio_image && img.result.vessel.ratio_image.replace('oss-cn-hongkong', 'oss-accelerate')
                doc.os_segmentation_image = img.result.vessel.segmentation_image && img.result.vessel.segmentation_image.replace('oss-cn-hongkong', 'oss-accelerate')
                doc.os_resized_image = img.result.vessel.resized_image && img.result.vessel.resized_image.replace('oss-cn-hongkong', 'oss-accelerate')
              }
              return img.url
            })
            doc.os_url = doc.os_url.join(',')
            doc.os_url = doc.os_url.replace('oss-cn-hongkong', 'oss-accelerate')
          }
        } catch (err) {
          console.log(err)
        }
        if (t.reportVersion === 'polymindamd') {
          t.diseases.push('amd')
        }
        eyes.map((eye) => {
          t.diseases.map((disease, index) => {
            if (['cvd', 'age', 'vessel'].indexOf(disease) === -1) {
              doc[`${eye}_${disease}_conf`] = t[eye].result && t[eye].result[disease] && t[eye].result[disease].conf
              // doc[`${eye}_${disease}_gradable`] = t[eye].result && t[eye].result[disease] && t[eye].result[disease].gradable
              doc[`${eye}_${disease}_grading`] = t[eye].result && t[eye].result[disease] && t[eye].result[disease].grading
            }
          })
        })
        // od, os, odQuality, osQuality, age
        if ((t.reportType === 'all' || t.reportType === 'v2' || t.reportType === 'vessel') &&
          ((t.od.result && t.od.result.public) || (t.os.result && t.os.result.public)) &&
          ((t.od.result && t.od.result.cvd) || (t.os.result && t.os.result.cvd))) {
          try {
            doc.cvd_result = this.getRank(
              t.od.result && t.od.result.cvd && t.od.result.cvd.who_pred,
              t.os.result && t.os.result.cvd && t.os.result.cvd.who_pred,
              t.od.result && t.od.result.public && t.od.result.public.quality,
              t.os.result && t.os.result.public && t.os.result.public.quality,
              t.age
            )
          } catch (err) {
            console.log(err)
          }
        }
        doc.diseases = t.diseases.join(',')
        return doc
      })
      sheet.table = XLSX.utils.json_to_sheet(table)
      sheet.sheetName = 'sheet1'
      xlsxUtil.openDownloadDialog(xlsxUtil.sheet2blob([sheet]), 'reports.xlsx')
    },
    getDate (createdAt) {
      return moment(createdAt).format('YYYY-MM-DD HH:mm')
    },
    openReport (row) {
      const lang = localStorage.getItem('lang') || 'tc'
      let url = `/report.html#/?mode=${this.mode}_out&id=${row._id}&from=doctor&lang=${lang}`
      if (row.reportType === 'vessel') {
        url = `/report.html#/vascular?mode=${this.mode}_out&id=${row._id}&from=doctor&lang=${lang}`
      }
      if (row.version === '1.2.0' || row.reportVersion === 'v2' || row.reportVersion === 'polymindamd') {
        url = `/report.html#/test?mode=${this.mode}_out&id=${row._id}&from=doctor&lang=${lang}`
      }
      if (row.reportType === 'dcm') {
        url = `/report.html#/dcm?mode=${this.mode}_out&id=${row._id}&from=doctor&lang=${lang}`
      }
      window.open(url)
    },
    openReportQRCode (row) {
      const lang = localStorage.getItem('lang') || 'tc'
      let url = `${window.location.origin}/report.html#/?mode=${this.mode}_out&id=${row._id}&lang=${lang}`
      if (row.reportType === 'vessel') {
        url = `${window.location.origin}/report.html#/vascular?mode=${this.mode}_out&id=${row._id}&flang=${lang}`
      }
      if (row.version === '1.2.0' || row.reportVersion === 'v2' || row.reportVersion === 'polymindamd') {
        url = `${window.location.origin}/report.html#/test?mode=${this.mode}_out&id=${row._id}&from=doctor&lang=${lang}`
      }
      const qrCode = qr.imageSync(url, 'L')
      this.qrID = row.patientId
      this.qrCode = `data:image/png;base64,${qrCode.toString('base64')}`
      this.qrCodeVisible = true
    },
    hideReport () {
      this.reportVisible = false
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    getClass (text, d) {
      if (d === 'cvd') {
      }
      if (text === 'ungradable' || text === 'Ungradable') {
        return 'info'
      }
      if (!text || text === 'negative' || text === 'low risk' || text === 'N/A') {
        return 'success'
      }
      return 'danger'
    },
    async getList () {
      this.loading = true
      let result = {}
      if (!this.pickerDate) {
        this.pickerDate = []
      }
      console.log(this.diseasesFilter)
      try {
        result = await this.$store.dispatch('getGradings', {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          patientId: this.patientId,
          assistantId: this.assistantId,
          mode: this.mode,
          disease: this.diseasesFilter[0] || '',
          diseaseGrading: this.diseasesFilter[1] || '',
          startDate: this.pickerDate[0] ? new Date(this.pickerDate[0]) : '',
          endDate: this.pickerDate[1] ? moment(this.pickerDate[1]).endOf('day').toDate() : '',
          accountId: this.accountId || 'all',
          organizationId: this.organizationId || 'all',
          reportType: this.reportType || '',
          // machineId: this.machineId,
          state: 'graded',
          searchStr: this.search
        })
      } catch (err) {
        console.log(err)
        this.$notify({
          title: '请求失败',
          type: 'error'
        })
        this.loading = false
        return false
      }
      const { code, data } = result.data
      const amdLabels = ['early_or_intermediate', 'late_dry', 'late_wet']
      const glaucomaArr = ['high risk', 'medium risk']
      if (code === 0) {
        data.gradings.map((g) => {
          const diseases = g.diseases
          const diseasesResults = diseases.map((d) => {
            const dResult = {
              disease: d,
              result: ''
            }
            const odResult = g.od.result && g.od.result[d]
            const osResult = g.os.result && g.os.result[d]
            if (['drnp', 'cataract', 'glaucoma', 'amd', 'other'].indexOf(d) > -1) {
              if (d === 'glaucoma') {
                dResult.result = 'negative'
                if ((odResult && odResult.grading === 'ungradable') || (osResult && osResult.grading === 'ungradable')) {
                  dResult.result = 'ungradable'
                }
                if ((odResult && glaucomaArr.indexOf(odResult.grading) > -1) || (osResult && glaucomaArr.indexOf(osResult.grading) > -1)) {
                  dResult.result = 'positive'
                }
              } else if (d === 'amd') {
                dResult.result = 'negative'
                if ((odResult && odResult.grading === 'ungradable') || (osResult && osResult.grading === 'ungradable')) {
                  dResult.result = 'ungradable'
                }
                if ((odResult && amdLabels.indexOf(odResult.grading) > -1) || (osResult && amdLabels.indexOf(osResult.grading) > -1)) {
                  dResult.result = 'positive'
                }
              } else {
                dResult.result = 'negative'
                if ((odResult && odResult.grading === 'ungradable') || (osResult && osResult.grading === 'ungradable')) {
                  dResult.result = 'ungradable'
                }
                if ((odResult && odResult.grading === 'positive') || (osResult && osResult.grading === 'positive')) {
                  dResult.result = 'positive'
                }
              }
            } else if (d === 'cvd' && (g.reportType === 'all' || g.reportType === 'vessel') &&
              ((g.od.result && g.od.result.public) || (g.os.result && g.os.result.public)) &&
              ((g.od.result && g.od.result.cvd) || (g.os.result && g.os.result.cvd))) {
              dResult.result = this.getRank(
                g.od.result && g.od.result.cvd && g.od.result.cvd.who_pred,
                g.os.result && g.os.result.cvd && g.os.result.cvd.who_pred,
                g.od.result && g.od.result.public && g.od.result.public.quality,
                g.os.result && g.os.result.public && g.os.result.public.quality,
                g.age
              )
            }
            return dResult
          })
          console.log(diseasesResults)
          // const odResult = g.od.result && g.od.result.public.image_capture
          // const osResult = g.os.result && g.os.result.public.image_capture
          // console.log(odResult, osResult)
          // diseasesResults.unshift({
          //   disease: 'fundus',
          //   result: (!odResult || !osResult) ? 'positive' : 'negative'
          // })
          g.diseasesResults = diseasesResults
        })
        this.gradings = data.gradings
        this.total = data.total
      }
      this.loading = false
    }
  }
}
</script>
